import React from "react";
import { Link } from "gatsby-plugin-intl";
import classnames from "classnames";
import Logo from "../../assets/Logo";
import MenuCloseIcon from "../../assets/MenuCloseIcon";
import cssClass from "./MobileNavigation.module.scss";
import { navigationSchemaWithHome } from "./navigation-schema";

import LanguagePicker from "./LanguagePicker";

const MobileNavigation = ({ isOpen, closeFunction }) => {
  return (
    <div
      className={classnames(cssClass.navigationOuter, {
        [cssClass.hidden]: !isOpen,
      })}
      aria-hidden={!isOpen}
    >
      <div className={cssClass.navigationInner}>
        <div className={cssClass.navigationAndLogoContainer}>
          <div className={cssClass.topRow}>
            <Link to="/">
              <Logo invert colorIcon />
            </Link>
            <button className={cssClass.closeButton} onClick={closeFunction}>
              <MenuCloseIcon />
            </button>
          </div>

          <nav className={cssClass.navigation}>
            <ul>
              {navigationSchemaWithHome.map((navigationItem) => {
                return (
                  <li key={navigationItem.title}>
                    <Link to={navigationItem.path}>{navigationItem.title}</Link>
                  </li>
                );
              })}
            </ul>
          </nav>
        </div>

        <div className={cssClass.languagePickerContainer}>
          <p>Language</p>
          <LanguagePicker isMobileNav={true} />
        </div>
      </div>
    </div>
  );
};

export default MobileNavigation;
